import { getSiteDomain, randomNum } from '../../utils/common';
import makeRequest from '../../utils/makeRequest';
import reducerRegistry from '../../reduxUtils/reducerRegistry';
import { TOI_LIVE_DOMAIN } from '../../constants';
import { updatelayoutAdsData } from '../../helpers/ads/revenueRedux';
import {
  arrayToHashMap,
  filteredDataForExitPoll,
  getSortedViewDataForLokSabha,
} from './utils/loksabhaComputation';

const reducerName = 'lokSabhaElection';
const createActionName = name => `toi/${reducerName}/${name}`;

const ELECTION_CONTENT_FEED_PATH =
  '/homepage_loksabha_election_feed/msid-108856498,feedtype-sjson.cms';

export const RECEIVE_ELECTION_DATA = createActionName('RECEIVE_ELECTION_DATA');
export const RECEIVE_ELECTION_RESULT_DATA = createActionName(
  'RECEIVE_ELECTION_RESULT_DATA',
);
export const HANDLE_ELECTION_DATA_ERROR = createActionName(
  'HANDLE_ELECTION_DATA_ERROR',
);

export const DATA_LOADING = createActionName('DATA_LOADING');

export const DATA_LOADED = createActionName('DATA_LOADED');

function receiveLokSabhaElectionData(data) {
  return {
    type: RECEIVE_ELECTION_DATA,
    payload: data,
  };
}

function receiveLokSabhaElectionResultData(data) {
  return {
    type: RECEIVE_ELECTION_RESULT_DATA,
    payload: data,
  };
}

function handleLokSabhaElectionDataError() {
  return {
    type: HANDLE_ELECTION_DATA_ERROR,
    payload: {},
  };
}

export function dataLoading() {
  return {
    type: DATA_LOADING,
    payload: {},
  };
}

export function dataLoaded() {
  return {
    type: DATA_LOADED,
    payload: {},
  };
}

// function fetchDataFromUrl(url) {
//   return makeRequest.get(url, 'skipfeedengine');
// }

async function fetchLokSabhaElectionData(data = null, feedUrl, web) {
  const requestParams = {
    params: {},
  };
  let response = data ? { data } : null;
  if (!response) {
    const feedPath = web ? `${feedUrl}?pfm=web` : feedUrl;
    const url = feedPath;
    response = await makeRequest.get(url, requestParams, 'skipfeedengine');
  }
  if (
    response?.data?.result?.scores?.url &&
    response?.data?.result?.starcandidate?.url
  ) {
    const scores = await makeRequest.get(
      `${response.data.result.scores.url}?t=${randomNum()}`,
      requestParams,
      'skipfeedengine',
    );
    const starCandidate = await makeRequest.get(
      `${response.data.result.starcandidate.url}?t=${randomNum()}`,
      requestParams,
      'skipfeedengine',
    );
    response.data.result.starcandidate.data = starCandidate.data;
    response.data.result.scores.data = scores.data;
  } else if (response?.data?.exitpoll?.url) {
    const exitpoll = await makeRequest.get(
      response.data.exitpoll.url,
      requestParams,
      'skipfeedengine',
    );
    response.data.exitpoll.data = exitpoll.data;
  }
  return response;
}

async function fetchExitPollData(exitPollResultObject) {
  const requestParams = {
    params: {},
  };
  const exitpoll = await makeRequest.get(
    exitPollResultObject.exitpoll.url,
    requestParams,
    'skipfeedengine',
  );
  exitPollResultObject.exitpoll.data = exitpoll.data;
  return exitPollResultObject;
}

async function fetchResultData(exitPollResultObject) {
  const requestParams = {
    params: {},
  };
  if (
    exitPollResultObject?.scores?.url &&
    exitPollResultObject?.starcandidate?.url
  ) {
    const scores = await makeRequest.get(
      `${exitPollResultObject?.scores?.url}?t=${randomNum()}`,
      requestParams,
      'skipfeedengine',
    );
    const starCandidate = await makeRequest.get(
      `${exitPollResultObject?.starcandidate?.url}?t=${randomNum()}`,
      requestParams,
      'skipfeedengine',
    );
    exitPollResultObject.starcandidate.data = starCandidate.data;
    exitPollResultObject.scores.data = scores.data;
  }
  return exitPollResultObject;
}

export function loadLokSabhaElectionData(
  data = null,
  url = `${getSiteDomain()}${ELECTION_CONTENT_FEED_PATH}`,
  web = true,
) {
  return dispatch =>
    // dispatch(dataLoading());
    fetchLokSabhaElectionData(data, url, web)
      .then(response => {
        // dispatch(dataLoaded());
        dispatch(receiveLokSabhaElectionData(response.data));
        if (typeof window === 'undefined' && response?.data?.ads) {
          dispatch(updatelayoutAdsData(response.data.ads));
        }
      })
      .catch(error => {
        //dispatch(dataLoaded());
        dispatch(handleLokSabhaElectionDataError(error));
      });
}

export function loadLokSabhaExitPoll(exitPollObject, loader = false) {
  return dispatch => {
    if (loader) {
      dispatch(dataLoading());
    }
    return fetchExitPollData(exitPollObject)
      .then(response => {
        if (loader) {
          dispatch(dataLoaded());
        }
        dispatch(receiveLokSabhaElectionData(response));
      })
      .catch(error => {
        if (loader) {
          dispatch(dataLoaded());
        }
        dispatch(handleLokSabhaElectionDataError(error));
      });
  };
}

export function loadLokSabhaResult(exitPollObject, loader = false) {
  return dispatch => {
    if (loader) {
      dispatch(dataLoading());
    }
    return fetchResultData(exitPollObject)
      .then(response => {
        if (loader) {
          dispatch(dataLoaded());
        }
        dispatch(receiveLokSabhaElectionResultData(response));
      })
      .catch(error => {
        if (loader) {
          dispatch(dataLoaded());
        }
        dispatch(handleLokSabhaElectionDataError(error));
      });
  };
}

export default function reducer(state = {}, action = {}) {
  // console.log(action);
  switch (action.type) {
    case DATA_LOADING: {
      return {
        ...state,
        dataLoading: true,
      };
    }
    case DATA_LOADED: {
      return {
        ...state,
        dataLoading: false,
      };
    }
    case RECEIVE_ELECTION_DATA: {
      const {
        refreshinterval = 0,
        exitpoll = {},
        displaytext = 'Loksabha Elections',
        path = TOI_LIVE_DOMAIN,
        shareTitle,
        hideexitheading = 0,
        datasource = '',
        keywords = {},
        breakingnews = [],
        states = [],
        liveblog = {},
        result = {},
        view,
        inpageminitv,
        infoMsg,
        infoMsgCommon,
        seatArrangementVS,
      } = action.payload;
      if (exitpoll?.url) {
        const exitPollSourceData = filteredDataForExitPoll(
          exitpoll?.data,
          states,
        );
        return {
          ...state,
          refreshinterval,
          electionData: exitpoll?.data ? exitpoll?.data : result?.scores?.data,
          sortedData: exitPollSourceData,
          starCandidateData: result?.starcandidate?.data,
          isExitPoll: !!exitpoll?.url,
          exitpoll,
          result,
          displaytext,
          keywords,
          breakingnews,
          states,
          liveblog,
          datasource,
          hideexitheading,
          path,
          shareTitle,
          view,
          inpageminitv,
          infoMsg,
          infoMsgCommon,
          seatArrangementVS,
        };
      }
      if (result.scores?.data) {
        const alMasterMap = arrayToHashMap(result.scores?.data?.al_master);
        const prMasterMap = arrayToHashMap(result.scores?.data?.pr_master);
        const sortedData = getSortedViewDataForLokSabha(
          result?.scores?.data,
          states,
          alMasterMap,
          prMasterMap,
        );
        const starCandidateData = result?.starcandidate?.data;
        return {
          ...state,
          refreshinterval,
          electionData: exitpoll?.data ? exitpoll?.data : result?.scores?.data,
          starCandidateData,
          sortedData,
          alMasterMap,
          prMasterMap,
          isExitPoll: !!exitpoll?.url,
          exitpoll,
          result,
          displaytext,
          keywords,
          breakingnews,
          states,
          liveblog,
          datasource,
          hideexitheading,
          path,
          shareTitle,
          view,
          inpageminitv,
          infoMsg,
          infoMsgCommon,
          seatArrangementVS,
        };
      }
      return { ...state };
    }
    case RECEIVE_ELECTION_RESULT_DATA: {
      const {
        refreshinterval = 0,
        exitpoll = {},
        displaytext = 'Loksabha Elections',
        path = TOI_LIVE_DOMAIN,
        shareTitle,
        hideexitheading = 0,
        datasource = '',
        keywords = {},
        breakingnews = [],
        states = [],
        liveblog = {},
        scores,
        starcandidate,
        view,
        infoMsg,
        infoMsgCommon,
        seatArrangementVS,
      } = action.payload;
      const result = { scores, starcandidate };
      const alMasterMap = arrayToHashMap(result.scores?.data?.al_master);
      const prMasterMap = arrayToHashMap(result.scores?.data?.pr_master);
      const sortedData = getSortedViewDataForLokSabha(
        result?.scores?.data,
        states,
        alMasterMap,
        prMasterMap,
      );
      const starCandidateData = result?.starcandidate?.data;
      return {
        ...state,
        refreshinterval,
        electionData: exitpoll?.data ? exitpoll?.data : result?.scores?.data,
        starCandidateData,
        sortedData,
        alMasterMap,
        prMasterMap,
        isExitPoll: false,
        exitpoll,
        result,
        displaytext,
        keywords,
        breakingnews,
        states,
        liveblog,
        datasource,
        hideexitheading,
        path,
        shareTitle,
        view,
        infoMsg,
        infoMsgCommon,
        seatArrangementVS,
      };
    }
    case HANDLE_ELECTION_DATA_ERROR: {
      return {
        ...state,
        electionData: {},
      };
    }

    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
